<template>
<section class="certificate-preview pt-5 pb-5">
    <v-container >
        <v-row class="align-center">
            <v-col cols="12" xs="12" sm="7" md="7">
                <v-carousel height="700" cycle hide-delimiter-background show-arrows-on-hover>
                  <v-carousel-item v-for="(screenshot,i) in pdfScreenshots" :key="i">
                    <v-img contain height="600" :src="screenshot" />
                  </v-carousel-item>
                </v-carousel>
            </v-col>
            <v-col class="text-center pb-5 mt-5 mb-5" cols="12" sm="5" md="5">
                <h3>{{ $t('headline') }}</h3>
                <p class="pa-3">
                    {{ $t('desc') }}
                </p>
                <v-menu offset-y>
                    <template v-slot:activator="{on, attrs}">
                        <v-btn color="primary" rounded depressed v-bind="attrs" v-on="on">
                            {{ $t('btn') }}
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(orderItem, index) in orderItems" :key="index"
                        @click="downloadCertificate(index)">
                                <v-list-item-title v-if="isDe" :href="orderItem.certificate_url">
                                    {{ $t('headline') }} {{ index + 1 }} -
                                    <span v-if="orderItem.order_item_category.parent">
                                    {{ orderItem.order_item_category.parent.name}}
                                    ({{orderItem.order_item_category.name}}) -
                                </span>
                                <span v-else>{{ orderItem.order_item_category.name}} -</span>
                                    {{ orderItem.created_on | moment("DD.MM.YYYY")}}
                                </v-list-item-title>
                                 <v-list-item-title v-else :href="orderItem.certificate_url_en">
                                    {{ $t('headline') }} {{ index + 1 }} -
                                    <span v-if="orderItem.order_item_category.parent">
                                    {{ orderItem.order_item_category.parent.name}}
                                    ({{orderItem.order_item_category.name}}) -
                                </span>
                                <span v-else>{{ orderItem.order_item_category.name}} -</span>
                                    {{ orderItem.created_on | moment("DD.MM.YYYY")}}
                                </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
        </v-row>
    </v-container>
    </section>
</template>

<i18n>
{
  "en": {
    "headline": "Certificate",
    "desc": "This certificate guarantees that a climate contribution has been made through the climate protection project named in the certificate.",
    "btn": "Download Certificates"
  },
  "de": {
    "headline": "Zertifikat",
    "desc": "Dieses Zertifikat garantiert, dass ein Klimabeitrag durch das im Zertifikat genannte Klimaschutzprojekt geleistet wurde.",
    "btn": "Zertifikate herunterladen"
  }
}
</i18n>

<script>
import axios from 'axios';
import download from 'downloadjs';

export default {
  name: 'CertificatePreview',
  props: {
    orderItems: {
      type: Array,
      required: true,
    },
  },
  methods: {
    downloadCertificate(index) {
      if (this.isDe) {
        axios.get(this.orderItems[index].certificate_url, { responseType: 'blob' })
          .then((response) => {
            download(response.data, 'certificate.pdf', 'binary/octet-stream');
          });
      } else {
        axios.get(this.orderItems[index].certificate_url_en, { responseType: 'blob' })
          .then((response) => {
            download(response.data, 'certificate.pdf', 'binary/octet-stream');
          });
      }
    },
  },
  computed: {
    isDe() {
      if (this.$i18n.locale === 'en') {
        return false;
      }
      return true;
    },
    pdfScreenshots() {
      const screenshots = [];
      if (this.$i18n.locale === 'en') {
        this.orderItems.forEach((orderItem) => {
          screenshots.push(orderItem.pdf_screenshot_en);
        });
      } else {
        this.orderItems.forEach((orderItem) => {
          screenshots.push(orderItem.pdf_screenshot);
        });
      }
      return screenshots;
    },
  },
};
</script>

<style lang="scss" scoped>
.certificate-preview {
    background-color: #011730;
    color: white;
}

</style>
